import { MenuButton, TableColumn, TableRow, CircularProgress } from 'react-md'
import type { Unit } from './types'
import { unitHeaders } from './constants'

type Props = {
	unit: Unit
	menuItems: any[] | null
	children: any
	processing: any
	handleOnClick: () => void
}

const UnitRow = ({
	unit,
	menuItems,
	children,
	processing,
	handleOnClick,
}: Props) => {
	const appendedMenuItems = menuItems ? [...menuItems] : null

	const menu = !appendedMenuItems ? null : (
		<MenuButton
			id={'menu-button'}
			icon
			menuItems={appendedMenuItems}
			centered
			anchor={{
				x: MenuButton.HorizontalAnchors['CENTER'],
				y: MenuButton.VerticalAnchors['CENTER'],
			}}
		>
			more_vert
		</MenuButton>
	)
	const getRowValue = (key: string) => {
		let value = unit[key]
		return value
	}

	const renderTableColumns = () => {
		return unitHeaders
			.filter((h) => h.show)
			.map((header) => {
				return (
					<TableColumn onClick={handleOnClick} key={String(header.key)}>
						<p>
							{
								//@ts-ignore TODO: REMOVE
								getRowValue(header.key)
							}
						</p>
					</TableColumn>
				)
			})
	}

	return (
		<TableRow key={unit.uuid}>
			{renderTableColumns()}
			<TableColumn key={'children'}>
				<div>
					{processing ? (
						<CircularProgress id="progress" style={{ marginTop: 0 }} />
					) : (
						menu
					)}
					{children}
				</div>
			</TableColumn>
		</TableRow>
	)
}

export default UnitRow
